import { render, staticRenderFns } from "./Paginador.vue?vue&type=template&id=d360c68e"
import script from "./Paginador.vue?vue&type=script&lang=js"
export * from "./Paginador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports